import { createElement } from 'react';
import { RouteObject, redirect } from 'react-router-dom';

import { projectCreatePageRoute } from 'pages/ProjectCreatePage';
import { projectUpdatePageRoute } from 'pages/ProjectUpdatePage';

import { PAGE_SIZE, DEFAULT_SORT_ORDER, getDefaultProjectStatus } from 'widgets/ProjectList';

import { isHasAccess, pathPermissions, replacePermissions } from 'features/validateAccess';

import { projectsService } from 'entities/project';

import { pathKeys } from 'shared/lib/react-router';

import ProjectsPage from './ProjectsPage';

export const projectsPageRoute: RouteObject = {
  path: '/accounts/:accountId/projects/',
  children: [
    {
      index: true,
      element: createElement(ProjectsPage),
      loader: async (args) => {
        const requiredPermissions = replacePermissions(pathPermissions.project.root, args.params);
        if (!isHasAccess(requiredPermissions)) {
          return redirect(pathKeys.dashboard());
        }

        if (!args.params.accountId) {
          return redirect(pathKeys.page404());
        }

        Promise.resolve(
          projectsService.prefetchQuery({
            accountId: args.params.accountId,
            page: 0,
            filter: getDefaultProjectStatus(),
            size: PAGE_SIZE,
            sort: DEFAULT_SORT_ORDER,
          }),
        );

        return args;
      },
    },
    projectCreatePageRoute,
    projectUpdatePageRoute,
  ],
};
